import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  // Cores padrão do tema
  private defaultColorScheme = {
    '50': '#E5FFF6',
    '100': '#C9FFEC',
    '200': '#99DFC1',
    '300': '#3AA06B',
    '400': '#11562F',
    '500': '#0A4020',
    '600': '#032911',
    '700': '#001D09',
    '800': '#212529',
    '900': '#000'
  };

  constructor() { }

  setColors() {
    console.log("Aplicando cores do tema");
    if (typeof window === 'undefined') return;
    
    const color_scheme_string = localStorage.getItem('color_scheme');
    let color_scheme;
    
    if (color_scheme_string) {
      color_scheme = JSON.parse(color_scheme_string);
      console.log("Usando esquema de cores personalizado:", color_scheme);
    } else {
      color_scheme = this.defaultColorScheme;
      console.log("Usando esquema de cores padrão:", color_scheme);
    }
    
    document.documentElement.style.setProperty('--50', color_scheme['50']);
    document.documentElement.style.setProperty('--100', color_scheme['100']);
    document.documentElement.style.setProperty('--200', color_scheme['200']);
    document.documentElement.style.setProperty('--300', color_scheme['300']);
    document.documentElement.style.setProperty('--400', color_scheme['400']);
    document.documentElement.style.setProperty('--500', color_scheme['500']);
    document.documentElement.style.setProperty('--600', color_scheme['600']);
    document.documentElement.style.setProperty('--700', color_scheme['700']);
    document.documentElement.style.setProperty('--800', color_scheme['800']);
    document.documentElement.style.setProperty('--900', color_scheme['900']);
  }

  applyThemeIfAvailable() {
    // Sempre aplica o tema - se não houver personalizado, usa o padrão
    this.setColors();
  }

  getDefaultColorScheme() {
    return { ...this.defaultColorScheme };
  }

  resetToDefaultColors() {
    console.log("Resetando para cores padrão");
    if (typeof window === 'undefined') return;
    
    const color_scheme = this.defaultColorScheme;
    
    document.documentElement.style.setProperty('--50', color_scheme['50']);
    document.documentElement.style.setProperty('--100', color_scheme['100']);
    document.documentElement.style.setProperty('--200', color_scheme['200']);
    document.documentElement.style.setProperty('--300', color_scheme['300']);
    document.documentElement.style.setProperty('--400', color_scheme['400']);
    document.documentElement.style.setProperty('--500', color_scheme['500']);
    document.documentElement.style.setProperty('--600', color_scheme['600']);
    document.documentElement.style.setProperty('--700', color_scheme['700']);
    document.documentElement.style.setProperty('--800', color_scheme['800']);
    document.documentElement.style.setProperty('--900', color_scheme['900']);
  }
}
